module.exports = __webpack_public_path__ + "img/flow4.68478bb6.png";